<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">匹配卡消耗数据</h1>
    <el-row :gutter="20" class="user-options">
      <el-col :span="6">
        <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-col>

      <el-col :span="3">
        <el-select style="width: 160px" v-model="channel" placeholder="">
          <el-option
            v-for="(item, itemIndex) in channelsList"
            v-bind:key="itemIndex"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select
          filterable
          style="width: 160px"
          v-model="country"
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in countryList"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select
          filterable
          style="width: 160px"
          v-model="language"
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in languageList"
            v-bind:key="itemIndex + 199"
            :label="item.language"
            :value="item.langCode"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <span>是否新用户</span>
        <el-select
          filterable
          style="width: 160px"
          v-model="isNew"
          placeholder=""
        >
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <span>是否付费用户</span>
        <el-select
          filterable
          style="width: 160px"
          v-model="isPay"
          placeholder=""
        >
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
      </el-col>
      <el-col :span="6">
        <el-button type="warning" @click="getDayChatDetai" :loading="login1">
          查询
        </el-button>
        <el-button type="success" @click="dwnDayChatDetai" :loading="login2">
          下载
        </el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table :data="dayChatDetailData" v-loading="login1" stripe border>
        <el-table-column prop="date" label="日期" width="180">
        </el-table-column>
        <el-table-column
          prop="todayConsumePeople"
          label="当日消耗人数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="todayConsumeOne"
          label="当日消耗1张人数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="todayConsumeTwo"
          label="当日消耗2张人数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="todayConsumeThree"
          label="当日消耗3张人数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="todayConsumeFourToFive"
          label="当日消耗4-5张人数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="todayConsumeSixToTen"
          label="当日消耗6-10张人数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="todayConsumeMore"
          label="当日消耗10张以上人数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="todayConsumeCards"
          label="当日消耗张数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="totalConsumePeople"
          label="累计消耗人数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="totalConsumeOne"
          label="累计消耗1张人数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="totalConsumeTwo"
          label="累计消耗2张人数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="totalConsumeThree"
          label="累计消耗3张人数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="totalConsumeFourToFive"
          label="累计消耗4-5张人数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="totalConsumeSixToTen"
          label="累计消耗6-10以上人数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="totalConsumeMore"
          label="累计消耗10张以上人数"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="totalConsumeCards"
          label="累计消耗张数"
          width="180"
        >
        </el-table-column>
        <el-table-column prop="avgCallTime" label="平均通话时长(s)" width="180">
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="user-options">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        class="pagination"
      ></el-pagination>
    </el-row>
  </el-card>
</template>

<script>
import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
import { getCountry, getLanguage } from '@/utils/normalApi.js'
export default {
  data () {
    return {
      // 加载
      login1: false,
      login2: false,
      // 用户id白名单 MultipartFile文件
      ridFile: '',
      // 代理名或者代理id
      agentName: '',
      // 通话日期
      platformData: [datainfor(1), datainfor(1)],
      retainedOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      channel: 'total', // 渠道号
      channelsList: this.$store.state.channels,
      language: 'all', // 语言
      languageList: [],
      country: 'total', // 国家
      countryList: [],
      // 分引
      page: 1,
      total: 0,
      // 表格数据
      dayChatDetailData: [],
      isPay: -1,
      isNew: -1
    }
  },
  created () {
    this.getDayChatDetai()
    this._getCountry()
    this._getLanguage()
  },
  methods: {
    // 查询列表
    async getDayChatDetai () {
      this.login1 = true

      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.matchCard_consume,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          channel: this.channel,
          language: this.language,
          country: this.country,
          isPay: this.isPay,
          isNew: this.isNew,
          page: this.page
        }
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      this.dayChatDetailData = res.data.data
      this.total = res.data.total
    },
    async _getCountry () {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
    async _getLanguage () {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
        this.language = res[0].langCode
      }
    },
    // 下载
    async dwnDayChatDetai () {
      this.login2 = true
      const res = await this.$axios({
        method: 'GET',
        url: this.$store.getters.path.matchCard_consume_download,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          channel: this.channel,
          language: this.language,
          country: this.country,
          start: this.platformData[0],
          isPay: this.isPay,
          isNew: this.isNew,
          end: this.platformData[1]
        }
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, '匹配卡消耗数据' + this.platformData[1])
    },
    // 分页
    handleCurrentChange () {
      this.getDayChatDetai()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }
}
</style>
